export const navigationLinks = [
    {
        name:'ABOUT ME',
        ref:'#about-me'
    },  {
        name:'RESUME',
        ref:'#resume'
    },
    {
        name:'CONTACT',
        ref:'#contact'
    },
]